export const Environment = () => {
    // return "development"; // Use Mocks
    return "production"; // Use Real APIs
}

export const isProduction = () => Environment() === 'production';

// export const useLocal = false; // Use APIs running in Azure APIM/Functions
export const useLocal = false; // Use APIs running in Docker-Compose / Visual Studio
export const useAzFunctionMsal = true; // Use Azure Function MSAL Authentication (if false, use local mock auth)